import connectRange, {
  RangeConnectorParams,
  RangeWidgetDescription,
} from "@hooks/search/connectors/connectRange"
import {
  AdditionalWidgetProperties,
  useConnector,
} from "react-instantsearch-core"

export type UseRangeProps = RangeConnectorParams

export function useRange(
  props: UseRangeProps,
  additionalWidgetProperties?: AdditionalWidgetProperties
) {
  return useConnector<RangeConnectorParams, RangeWidgetDescription>(
    connectRange,
    props,
    additionalWidgetProperties
  )
}
